import { render } from "./exchangeRecord.vue?vue&type=template&id=2fc06dd1&scoped=true"
import script from "./exchangeRecord.vue?vue&type=script&lang=js"
export * from "./exchangeRecord.vue?vue&type=script&lang=js"

import "./exchangeRecord.vue?vue&type=style&index=0&id=2fc06dd1&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc06dd1"]])

export default __exports__